import { FC, ReactNode, useState } from 'react';
import { Layout, Menu, Button, message } from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { DollarOutlined, LineChartOutlined, LogoutOutlined } from '@ant-design/icons';

const { Header, Content, Sider } = Layout;

interface MainLayoutProps {
  children: ReactNode;
}

const MainLayout: FC<MainLayoutProps> = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = [
    {
      key: '/price-offset',
      icon: <DollarOutlined />,
      label: <Link to="/price-offset">价格偏移</Link>,
    },
    {
      key: '/price-simulation',
      icon: <LineChartOutlined />,
      label: <Link to="/price-simulation">价格模拟</Link>,
    },
  ];

  const handleLogout = () => {
    localStorage.removeItem('token');
    message.success('退出登录成功');
    navigate('/login');
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header className="header">
        <div className="header-container">
          <div className="logo">价格调整系统</div>
          <div className="header-right">
            <Button 
              type="primary" 
              icon={<LogoutOutlined />} 
              onClick={handleLogout}
              ghost
            >
              退出登录
            </Button>
          </div>
        </div>
      </Header>
      <Layout>
        <Sider 
          collapsed={collapsed} 
          onCollapse={value => setCollapsed(value)}
          width={200}
          className="site-layout-background"
        >
          <Menu
            mode="inline"
            selectedKeys={[location.pathname]}
            style={{ height: '100%', borderRight: 0 }}
            items={menuItems}
          />
        </Sider>
        <Layout style={{ padding: '24px' }}>
          <Content
            className="site-layout-background"
            style={{
              padding: 24,
              margin: 0,
              minHeight: 280,
            }}
          >
            {children}
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default MainLayout; 